/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { getAllDocuments } from "../../../Services/DocumentUpload/documentUploadApi";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { capitalizeWords } from "../../../Utils/LetterCase";
import UploadDocuments from "./Documents/UploadDocuments";
import DocumentTable from "./Documents/DocumentTable";
import Analyze from "./Analyze/Analyze";
import Laws from "./Laws/Laws";
import Rating from "./Rating/Rating";
import "./Compliance.css";
import SyncRules from "./Documents/SyncRules";
import OverallRating from "./Rating/OverallRating";
import AddToLibrary from "./Laws/AddToLibrary";

const Compliance = () => {
  const [documentData, setDocumentData] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("documents");
  const userId = localStorage.getItem("user_id");
  const communityId = location.state?.communityId;
  const communityName = location.state?.communityName;
  const [refetchDox, setRefetchDox] = useState(false);

  const tabs = useMemo(
    () => [
      {
        key: "documents",
        label: "Documents",
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            width="40"
            height="40"
            x="0"
            y="0"
            viewBox="0 0 512 512"
            className=""
          >
            <g>
              <path
                d="M433.798 106.268l-96.423-91.222C327.119 5.343 313.695 0 299.577 0H116C85.673 0 61 24.673 61 55v402c0 30.327 24.673 55 55 55h280c30.327 0 55-24.673 55-55V146.222c0-15.049-6.27-29.612-17.202-39.954zM404.661 120H330c-2.757 0-5-2.243-5-5V44.636zM396 482H116c-13.785 0-25-11.215-25-25V55c0-13.785 11.215-25 25-25h179v85c0 19.299 15.701 35 35 35h91v307c0 13.785-11.215 25-25 25z"
                fill="#dd483b"
                opacity="1"
              />
              <path
                d="M363 200H143c-8.284 0-15 6.716-15 15s6.716 15 15 15h220c8.284 0 15-6.716 15-15s-6.716-15-15-15zM363 280H143c-8.284 0-15 6.716-15 15s6.716 15 15 15h220c8.284 0 15-6.716 15-15s-6.716-15-15-15zM215.72 360H143c-8.284 0-15 6.716-15 15s6.716 15 15 15h72.72c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
                fill="#dd483b"
                opacity="1"
              />
            </g>
          </svg>
        ),
      },
      {
        key: "analyze",
        label: "Analyze",
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            width="40"
            height="40"
            x="0"
            y="0"
            viewBox="0 0 56.966 56.966"
            className=""
          >
            <g>
              <path
                d="M55.146 51.887 41.588 37.786A22.926 22.926 0 0 0 46.984 23c0-12.682-10.318-23-23-23s-23 10.318-23 23 10.318 23 23 23c4.761 0 9.298-1.436 13.177-4.162l13.661 14.208c.571.593 1.339.92 2.162.92.779 0 1.518-.297 2.079-.837a3.004 3.004 0 0 0 .083-4.242zM23.984 6c9.374 0 17 7.626 17 17s-7.626 17-17 17-17-7.626-17-17 7.626-17 17-17z"
                fill="#428dfd"
                opacity="1"
              />
            </g>
          </svg>
        ),
      },
      {
        key: "laws",
        label: "Laws",
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            width="40"
            height="40"
            x="0"
            y="0"
            viewBox="0 0 53 53"
            className=""
          >
            <g>
              <path
                d="M48.076 37.11 30.216 21.25l-3.49 3.49 15.86 17.86a3.896 3.896 0 0 0 5.68.18 3.884 3.884 0 0 0-.19-5.67zM26.716 41.02c0-1.79-1.45-3.23-3.23-3.23h-13.16c-1.78 0-3.23 1.44-3.23 3.23v1.44h19.62v-1.44zM26.986 43.46H6.826c-1.78 0-3.23 1.44-3.23 3.23v2.55c0 .61.5 1.11 1.11 1.11h24.4c.62 0 1.11-.5 1.11-1.11v-2.55c0-1.79-1.45-3.23-3.23-3.23zM13.121 17.836 23.328 7.63l9.536 9.536-10.207 10.206zM33.77 16.668c.94.939 2.459.939 3.398 0a2.401 2.401 0 0 0 0-3.398l-9.922-9.922a2.368 2.368 0 0 0-1.699-.698 2.368 2.368 0 0 0-1.699.698c-.939.94-.939 2.46 0 3.398zM18.752 31.686a2.401 2.401 0 0 0 3.398 0 2.401 2.401 0 0 0 0-3.397l-9.922-9.922a2.404 2.404 0 0 0-3.398 3.398z"
                fill="#ff6325"
                opacity="1"
              />
            </g>
          </svg>
        ),
      },
      {
        key: "rating",
        label: "Rating",
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            width="40"
            height="40"
            x="0"
            y="0"
            viewBox="0 0 511.987 511"
            className=""
          >
            <g>
              <path
                fill="#ffc107"
                d="M510.652 185.902a27.158 27.158 0 0 0-23.425-18.71l-147.774-13.419-58.433-136.77C276.71 6.98 266.898.494 255.996.494s-20.715 6.487-25.023 16.534l-58.434 136.746-147.797 13.418A27.208 27.208 0 0 0 1.34 185.902c-3.371 10.368-.258 21.739 7.957 28.907l111.7 97.96-32.938 145.09c-2.41 10.668 1.73 21.696 10.582 28.094 4.757 3.438 10.324 5.188 15.937 5.188 4.84 0 9.64-1.305 13.95-3.883l127.468-76.184 127.422 76.184c9.324 5.61 21.078 5.097 29.91-1.305a27.223 27.223 0 0 0 10.582-28.094l-32.937-145.09 111.699-97.94a27.224 27.224 0 0 0 7.98-28.927z"
                opacity="1"
              />
            </g>
          </svg>
        ),
      },
    ],
    []
  );

  const fetchDocuments = useCallback(() => {
    dispatch(
      getAllDocuments({
        community_id: communityId,
        access: "all",
        user_id: userId,
      })
    )
      .unwrap()
      .catch(() => {
        toast.error("Failed to fetch document.");
      });
  }, [dispatch, communityId, documentData, userId, refetchDox]);

  useEffect(() => {
    fetchDocuments();
  }, [fetchDocuments]);

  const handleSetDocumentData = useCallback((data) => {
    setDocumentData(data);
  }, []);

  const renderTabContent = () => {
    switch (activeTab) {
      case "documents":
        return (
          <DocumentTable
            communityIdForDoc={communityId}
            refetchDox={refetchDox}
            handleRefetchDox={() => setRefetchDox(!refetchDox)}
          />
        );
      case "analyze":
        return <Analyze />;
      case "laws":
        return <Laws />;
      case "rating":
        return <Rating />;
      default:
        return null;
    }
  };

  return (
    <>
      <div className="back-btn">
        <button onClick={() => navigate(-1)} className="back-btn-button">
          <ArrowBackIcon className="left-icon" />
          Back
        </button>
      </div>
      <div className="community-section">
        <div className="community-inner-wrap user-management-flow">
          <div className="add-new-community d-flex justify-content-between align-items-center">
            <div className="community-heading create-new">
              {capitalizeWords(communityName)}
            </div>
            <div className="d-flex gap-2 align-items-center">
              {(activeTab === "documents" || activeTab === "analyze") && (
                <>
                  {/* <SyncRules
                    communityId={communityId}
                    handleRefetchDox={() => setRefetchDox(!refetchDox)}
                  /> */}
                  <UploadDocuments
                    commmunityId={communityId}
                    setDocumentData={handleSetDocumentData}
                    handleRefetchDox={() => setRefetchDox(!refetchDox)}
                  />
                </>
              )}
              {activeTab === "laws" && <AddToLibrary />}
              {/* {activeTab === "rating" && <OverallRating />} */}
            </div>
          </div>
          <div className="d-flex justify-content-between align-items-center rating-box-res">
            <div className="d-flex gap-4 mb-4 flex-wrap">
              {tabs.map(({ key, label, icon }) => (
                <button
                  key={key}
                  type="button"
                  className={`btn btn-outline-secondary d-flex flex-column align-items-center rounded-4 justify-content-center gap-2 border-2 btn-compliance-navigation btn-compliance-box ${
                    activeTab === key ? "activetab" : ""
                  }`}
                  onClick={() => setActiveTab(key)}
                  data-tab-type={key}
                >
                  {icon}
                  {label}
                </button>
              ))}
            </div>
            {activeTab === "rating" && <OverallRating />}
          </div>

          <div className="create-comm-inner-wrap upload-docs-table">
            {renderTabContent()}
          </div>
        </div>
      </div>
    </>
  );
};

export default Compliance;
